module.exports = __webpack_public_path__ + "img/jobs.ed8942fe.svg";